module.exports = __webpack_public_path__ + "static/media/bug.faf06398.svg";